import { render, staticRenderFns } from "./budgetPlan.vue?vue&type=template&id=97cb7a1a&scoped=true"
import script from "./budgetPlan.vue?vue&type=script&lang=js"
export * from "./budgetPlan.vue?vue&type=script&lang=js"
import style0 from "./budgetPlan.vue?vue&type=style&index=0&id=97cb7a1a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cb7a1a",
  null
  
)

export default component.exports